import axios from 'axios';
import { LogService } from '../../../../services/log-service';

const updateShipstationSellerProviderSettings = async (sellerLabelProviderId, nickname, isPrimaryAccount) => {
  try {
    const data = { nickname, isPrimaryAccount };
    const response = await axios.put(`/sellerProvider/${sellerLabelProviderId}/settings`, data);
    return response?.data ?? [];
  } catch (error) {
    LogService.logError(new Error('Error updating seller provider settings', { cause: error }));
    throw error;
  }
};

export default updateShipstationSellerProviderSettings;
